import { Button, ButtonVariant } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { type FC } from 'react'

export const NotFound404: FC = () => {
  const { t } = useTranslation('features-system')
  const { navigate } = useRouter()

  return (
    <div
      className="egw-container min-h-[calc(100vh-72px)] overflow-hidden md:min-h-fit md:my-20 flex justify-center "
      data-testid="404-not-found"
    >
      <div className="flex flex-col items-center text-center">
        <h1 className="text-[8rem] font-light text-header font-noto mb-[7rem]">{t('not_found_404.404')}</h1>
        <p className="text-base text-body mb-8">
          <span>{t('not_found_404.page_not_found_p1')}</span>
          <br />
          <span>{t('not_found_404.page_not_found_p2')}</span>
        </p>
        <Button
          testId="navigate-to-overview"
          className="w-fit"
          variant={ButtonVariant.Primary}
          onClick={() => {
            navigate(WEALTH_ROUTES.OVERVIEW.path)
          }}
        >
          {t('not_found_404.go_home')}
        </Button>
      </div>
    </div>
  )
}
